module.exports = __webpack_public_path__ + "img/pro_four_6.34935cee.jpg";